<template>
  <Backdrop v-if="open" @click="handleClick" style="z-index: 20000">
    <div
      ref="root"
      class="message-box border-0 py-4 px-6 rounded-lg"
      :class="type"
    >
      <div class="flex mt-2">
        <div
          class="
            message-box-icon
            mr-4
            w-12
            h-12
            flex
            items-center
            justify-center
            rounded-full
            flex-shrink-0
          "
        >
          <template v-if="type == 'success'">
            <i class="far fa-check-circle" />
          </template>
          <template v-if="type == 'warning'">
            <i class="far fa-exclamation-circle" />
          </template>
          <template v-if="type == 'info'">
            <i class="far fa-info-circle text-dull-dark" />
          </template>
        </div>
        <div>
          <Typography variant="headingThree">{{ title }}</Typography>
          <div class="w-full text-dull-dark text-sm mt-2 mb-4">
            {{ message }}
          </div>
        </div>
      </div>

      <div class="flex items-center justify-end">
        <Button
          color="default"
          variant="basic"
          v-if="cancelButtonText"
          @click.native="reject"
          class="mr-4"
        >
          {{ cancelButtonText }}
        </Button>
        <form @submit.prevent="confirm">
          <template v-if="type == 'success'">
            <Button color="success">
              {{ confirmButtonText }}
            </Button>
          </template>
          <template v-if="type == 'warning'">
            <Button color="danger">
              {{ confirmButtonText }}
            </Button>
          </template>
          <template v-if="type == 'info'">
            <Button color="primary">
              {{ confirmButtonText }}
            </Button>
          </template>
        </form>
      </div>
    </div>
  </Backdrop>
</template>
<script>
import Backdrop from '../Backdrop';
import InputField from '../InputField';
import Icon from '../Icon';
import IconButton from '../IconButton';
import Button from '../Button';
import Typography from '../Typography';

const MessageBox = {
  name: 'MessageBox',

  components: {
    Backdrop,
    Icon,
    IconButton,
    Button,
    InputField,
    Typography,
  },

  data: () => ({
    type: '',
    title: '',
    message: '',
    closeOnConfirm: true,
    closeOnReject: true,
    confirmButtonText: 'Ok',
    cancelButtonText: 'Close',
    open: false,
    resolveFunction: null,
    rejectFunction: null,
    /* If set's to true, it rejects, and should be used in a catch block,
     if set to false it will resolve with the value false */
    rejectOnReject: false,
  }),
  methods: {
    confirm() {
      if (this.closeOnConfirm) {
        this.open = false;
      }
      if (typeof this.resolveFunction === 'function') {
        this.resolveFunction(true);
      }
    },
    reject() {
      if (this.closeOnReject) {
        this.open = false;
      }

      if (typeof this.rejectFunction === 'function' && this.rejectOnReject) {
        this.rejectFunction(false);
      } else if (typeof this.resolveFunction === 'function') {
        this.resolveFunction(false);
      }
    },

    handleClick(e) {
      /* it's possible that another click event lower in the propagation chain
       * has already unmounted this node
       */
      if (!this.$refs.root) {
        return;
      }

      /*
       * this could also be in the Backdrop checking for
       * event.currentTarget I suppose
       */
      if (!this.$refs.root.contains(e.target)) {
        this.open = false;
      }
    },
  },
};

export default MessageBox;
</script>

<style scoped>
.message-box {
  position: absolute;
  z-index: 1000;
  max-width: 500px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @apply border
      border-solid
      border-dull
      bg-white;
}

.message-box.success .message-box-icon {
  @apply bg-success-light;
}

.message-box.success .message-box-icon i {
  @apply text-success-dark;
}

.message-box.warning .message-box-icon {
  @apply bg-danger-light;
}

.message-box.warning .message-box-icon i {
  @apply text-danger-dark;
}
</style>
